import http from '@/utils/http'

// get请求
export default{
	//channelList
	getChannelList(params){
		return http.get('/api/channel/lists',params)
	},
	//公告列表
	getNoticeList(params){
		return http.get('/api/article/lists',params)
	},
	//公告详情
	getNoticeDetail(params){
		return http.get('/api/article/detail',params)
	},
	//品牌详情
	getBrandDetail(params){
		return http.get('/api/brand/page_info',params)
	}
	
}


// WEBPACK FOOTER //
// ./src/api/api.js